import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const ProductInventoryListTemplate = props => {
	const { productDetailViewStore, actions, t } = props;
	const {
		loading,
		listStore,
		tableData,
		queryUtility,
		noDataItem,
		editField,
		edit,
		remove,
		cancel,
		update,
		product,
		updateTable, // DO NOT DELETE! Used for re-render.
		productInventory,
		onItemChange,
		openDescriptionModal,
		onCancelBatch,
		allowEdit,
		addRow,
		confirmDisabled,
		cancelDisabled,
		organizationsCount,
		isSeller,
		isSuperAdminOrganization,
		removeRow,
		onInventoryLogPerWarehouse,
		showCustomActions,
	} = productDetailViewStore;
	if (loading) return <Loader />;
	return (
		<section>
			{(isSeller || isSuperAdminOrganization) && (
				<div className="flex flex--secondary spc--top--sml spc--left--sml spc--right--sml">
					{productInventory.length < organizationsCount && (isSeller || isSuperAdminOrganization) && (
						<button
							className="btn btn--med btn--primary spc--bottom--sml"
							disabled={product.isMultiProduct}
							onClick={() => addRow()}
						>
							<i className="fa fa-plus spc--right--tny align--v--middle"></i>
							{t('ADDINVENTORYDATA')}
						</button>
					)}
					{productInventory.length != 0 && (
						<div className="align--h--right">
							<button
								className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
								onClick={openDescriptionModal}
								disabled={confirmDisabled}
							>
								{t('CONFIRM')}
							</button>
							<button
								className="btn btn--med btn--ghost spc--bottom--sml"
								onClick={onCancelBatch}
								disabled={cancelDisabled}
							>
								{t('CANCEL')}
							</button>
						</div>
					)}
				</div>
			)}
			<BaasicTable
				listEmptyKey="LISTEMPTY.PRODUCTINVENTORY"
				{...{
					listStore,
					data: productInventory.slice(),
					tableData,
					queryUtility,
					productDetailViewStore,
					actions,
					noDataItem,
					editField: !product.isMultiProduct ? editField : null,
					edit,
					remove,
					cancel,
					update,
					onItemChange,
					allowEdit,
					removeRow,
					onInventoryLogPerWarehouse,
					showCustomActions,
				}}
				viewStore={productDetailViewStore}
				rowRender={InventoryTableRowRender}
			/>
		</section>
	);
};

function InventoryTableRowRender(trElement, { dataItem }) {
	const className = dataItem.isNewRow ? 'is-new' : '';
	return <tr className={className}>{trElement.props.children}</tr>;
}

export default defaultTemplate(ProductInventoryListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/ProductInventoryListTemplate.jsx